'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccessibleTextArea = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _sharedFieldErrorWrapper = require('@bibliocommons/shared-field-error-wrapper');

var _sharedFieldErrorWrapper2 = _interopRequireDefault(_sharedFieldErrorWrapper);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

require('../styles/AccessibleTextArea.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccessibleTextArea = exports.AccessibleTextArea = function (_BcReactComponent) {
  _inherits(AccessibleTextArea, _BcReactComponent);

  function AccessibleTextArea(props) {
    _classCallCheck(this, AccessibleTextArea);

    var _this = _possibleConstructorReturn(this, (AccessibleTextArea.__proto__ || Object.getPrototypeOf(AccessibleTextArea)).call(this, props));

    var value = _this.props.value || '';
    _this.state = {
      remainingCount: _this.props.maxLength - value.length,
      height: '0'
    };

    _this.bindAll('handleChange', 'handlePaste', 'renderRemainingCount', 'updateRemainingCount', 'getTextAreaStyle', 'updateHeightToFitText');
    return _this;
  }

  _createClass(AccessibleTextArea, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.fitToText) {
        this.updateHeightToFitText();
      }
    }
  }, {
    key: 'getTextAreaStyle',
    value: function getTextAreaStyle() {
      if (!this.state.height || !this.props.fitToText) {
        return {};
      }
      return { height: this.state.height + 'px' };
    }
  }, {
    key: 'handleChange',
    value: function handleChange() {
      var value = this._textarea.value;
      if (this.props.maxLength) {
        this.updateRemainingCount(value.length);
      }

      if (this.props.handleChange) {
        this.props.handleChange(value);
      }

      if (this.props.fitToText) {
        this.updateHeightToFitText();
      }
    }
  }, {
    key: 'handlePaste',
    value: function handlePaste(e) {
      var value = e.clipboardData.getData('Text');
      if (this.props.maxLength) {
        this.updateRemainingCount(value.length);
      }
      if (this.props.handlePaste) {
        this.props.handlePaste(value);
      }
    }
  }, {
    key: 'updateRemainingCount',
    value: function updateRemainingCount(charactersUsed) {
      this.setState({
        remainingCount: this.props.maxLength - charactersUsed || 0
      });
    }
  }, {
    key: 'updateHeightToFitText',
    value: function updateHeightToFitText() {
      var _this2 = this;

      // Set the height to 0 so scrollHeight will reflect true height of text
      // (this is necessary because the scrollHeight is not updated when text is removed)
      // See http://bdadam.com/blog/automatically-adapting-the-height-textarea.html
      this.setState({ height: '0' }, function () {
        _this2.setState({ height: '' + _this2._textarea.scrollHeight });
      });
    }
  }, {
    key: 'renderRemainingCount',
    value: function renderRemainingCount() {
      if (!this.props.maxLength) {
        return null;
      }
      var warningClass = '';

      if (this.state.remainingCount <= 10) {
        warningClass = 'warning';
      }

      return _react2.default.createElement(
        'small',
        { className: 'remaining-characters ' + warningClass, 'aria-live': 'polite', 'aria-atomic': 'true' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'characters_remaining',
          values: {
            remaining: this.state.remainingCount.toString()
          } })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          value = _props.value,
          placeholder = _props.placeholder,
          className = _props.className,
          labelledById = _props.labelledById,
          describedById = _props.describedById,
          disabled = _props.disabled,
          required = _props.required,
          maxLength = _props.maxLength,
          name = _props.name,
          handleFocus = _props.handleFocus,
          handleBlur = _props.handleBlur,
          setFocus = _props.setFocus,
          textAreaProps = _objectWithoutProperties(_props, ['value', 'placeholder', 'className', 'labelledById', 'describedById', 'disabled', 'required', 'maxLength', 'name', 'handleFocus', 'handleBlur', 'setFocus']);

      var maxWarning = this.state.remainingCount <= 10 && !!maxLength ? 'has-error' : '';
      var textAreaClass = 'form-control ' + className;
      return _react2.default.createElement(
        'div',
        { className: 'cp-accessible-text-area clearfix ' + maxWarning },
        _react2.default.createElement('textarea', _extends({
          className: textAreaClass, 'aria-labelledby': labelledById,
          'aria-describedby': describedById,
          placeholder: placeholder,
          defaultValue: value,
          disabled: disabled,
          maxLength: maxLength,
          required: required,
          name: name,
          ref: function ref(el) {
            _this3._textarea = el;
          },
          onChange: this.handleChange,
          onPaste: this.handlePaste,
          onFocus: handleFocus,
          onBlur: handleBlur,
          autoFocus: setFocus,
          'data-test-id': this.props.testId,
          style: this.getTextAreaStyle()
        }, textAreaProps)),
        this.renderRemainingCount()
      );
    }
  }]);

  return AccessibleTextArea;
}(_baseBcReactComponent2.default);

AccessibleTextArea.propTypes = {
  id: _react.PropTypes.string,
  labelledById: _react.PropTypes.string.isRequired,
  describedById: _react.PropTypes.string,
  disabled: _react.PropTypes.bool,
  fitToText: _react.PropTypes.bool,
  errorKey: _react.PropTypes.string.isRequired,
  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
    classification: _react.PropTypes.string,
    message: _react.PropTypes.string
  })),
  required: _react.PropTypes.bool,
  maxLength: _react.PropTypes.number,
  name: _react.PropTypes.string,
  className: _react.PropTypes.string,
  setFocus: _react.PropTypes.bool,
  placeholder: _react.PropTypes.string,
  value: _react.PropTypes.string,
  testId: _react.PropTypes.string,
  handleChange: _react.PropTypes.func,
  handlePaste: _react.PropTypes.func,
  handleFocus: _react.PropTypes.func,
  handleBlur: _react.PropTypes.func
};

AccessibleTextArea.defaultProps = {
  className: '',
  fitToText: false
};

exports.default = (0, _sharedFieldErrorWrapper2.default)(AccessibleTextArea);


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/accessibility/text-area/lib/components/AccessibleTextArea.component.js
// module id = 355
// module chunks = 0 1 4